import throttle from '../util/throttle';

export default class FixedScroller {

  /*
  * Fires first
  */
  constructor() {


    this.$section = $('.fixed-scroller');

    this.$fixedContent = this.$section.find('.fixed-scroller__side--sticky .fixed-scroller__content');

    this.windowHeight = $(window).height();
    this.windowWidth = $(window).width();


    if (!this.$section.length) return;

    if (this.windowWidth >= 768) {
      this.setDynamicParameters();
      this.addEventListeners();
    }
  }


  addEventListeners() {

    $(window).on('resize', () => {
      this.setDynamicParameters();
    });

    $(window).scroll(throttle(() => {
      this.scrollTop = $(window).scrollTop();

      if (this.windowWidth >= 768) {
        this.updateFixedStatus();
      }
    }, 20));
  }

  setDynamicParameters() {

    setTimeout(() => {

      this.windowHeight = $(window).height();
      this.windowWidth = $(window).width();
      this.sectionOffsetTop = this.$section.offset().top;
      this.sectionHeight = this.$section.height();
      this.contentHeight = this.$fixedContent.outerHeight() + 25;

      this.$fixedContent.attr('style', '');
      this.$fixedContent.width(this.$fixedContent.width());
    }, 2000);
  }

  updateFixedStatus() {
    let sectionOffsetBottom = this.sectionOffsetTop + this.sectionHeight;

    let hasScrolledAboveSection = this.scrollTop < this.sectionOffsetTop;
    let isScrollingOverSection = this.scrollTop >= this.sectionOffsetTop;
    let hasScrolledPastSection = this.scrollTop > sectionOffsetBottom - (this.contentHeight);

    // Scrolling above section or
    if (hasScrolledAboveSection) {
      this.$fixedContent.removeClass('fixed-scroller__content--fixed');
    }

    // Scrolling over section
    if (isScrollingOverSection && !hasScrolledPastSection) {
      this.$fixedContent.addClass('fixed-scroller__content--fixed');
      this.$fixedContent.removeClass('fixed-scroller__content--end');
    }

    // Scrolling below section
    if (hasScrolledPastSection) {
      this.$fixedContent.addClass('fixed-scroller__content--end');
    }
  }

}
new FixedScroller();



// WEBPACK FOOTER //
// ./scripts/gutenberg_components/_contact-form.js